import { batch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { doRequest } from '@r1-frontend/do-request/index';
import { agreements, ResponseDto } from '@r1-frontend/api-domru/core-profile/v2/user/agreements';
import { setAgreements, setStatus } from '@r1-frontend/entities/stores/auth/actionCreators';
import { catch401 } from '@r1-frontend/entities/stores/auth/helpers/catch401';
import { TState } from '@r1-frontend/entities/stores/auth/reducer';
import { selectIsAuth } from '@r1-frontend/entities/stores/auth/selectors/selectIsAuth';


const getAgreements = () => async(dispatch: ThunkDispatch<TState, void, AnyAction>, getState: () => TState) => {
    const state = getState();
    const isAuth = selectIsAuth(state);

    if (!isAuth) {
        return;
    }

    dispatch(setStatus('loading'));

    const response = await doRequest.coreProfile<ResponseDto>(agreements());

    if (!response.isSuccess) {
        dispatch(setStatus('error'));
        catch401(response.error);
        return;
    }

    batch(() => {
        dispatch(setAgreements(response.payload));
        dispatch(setStatus('complete'));
    });
};

export default getAgreements;
